<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('modification.changenameaddress.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('modification.changenameaddress.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.changenameaddress.fields.step_01') }}</h2>
              <p>{{ $t('modification.changenameaddress.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('modification.changenameaddress.fields.step_02') }}</h2>
              <p>{{ $t('modification.changenameaddress.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('modification.changenameaddress.fields.step_03') }}</h2>
              <p>{{ $t('modification.changenameaddress.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                v-model="activeTab"
                class="my_app_tabs_data type2"
                hide-slider
                grow
              >
                <v-tab :href="'#tab-1'" class="mw-200">{{ $t('myrequest.list.fields.request_data')  }}</v-tab>
                <v-tab :href="'#tab-2'" class="mw-200">{{ $t('myrequest.list.fields.attached_documents')  }}</v-tab>

                <v-tab-item :value="`tab-1`">
                  <ApplicationInformation :receipt_no.sync = receipt_no class="mt-15"/>
                  <div v-show="name_addr.ind_change_applicant == 'Y'">
                    <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.applicant2') }}</h2>
                    <v-row class="mt-25">
                      <v-col cols="12" class="pb-0">
                        <div class="floating__title__self">{{ $t('common.button.before') }}</div>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-data-table
                          :headers="$getHeaderType1(applicantHeaderTxt, applicantHeaders)"
                          :items="beforeApplicantList"
                          hide-default-footer
                          disable-pagination
                          class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
                        >
                          <template v-slot:item="{ item, index }">
                            <tr>
                              <td class="text-center">
                                {{ index + 1 }}
                              </td>
                              <td>
                                <p>{{ item.name_ar }}</p>
                                <p>{{ item.name_en }}</p>
                              </td>
                              <td>
                                <p style="white-space: break-spaces;">{{ item.address_ar }}</p>
                                <p style="white-space: break-spaces;">{{ item.address_en }}</p>
                              </td>
                              <td>
                                {{ item.nationality_code }}
                              </td>
                              <td>
                                {{ item.residence_country_code }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row class="mt-25">
                      <v-col cols="12" class="pb-0">
                        <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-data-table
                          :headers="$getHeaderType1(applicantHeaderTxt, applicantHeaders)"
                          :items="afterApplicantList"
                          hide-default-footer
                          disable-pagination
                          class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
                        >
                          <template v-slot:item="{ item, index }">
                            <tr>
                              <td class="text-center">
                                {{ index + 1 }}
                              </td>
                              <td>
                                <p>{{ item.name_ar }}</p>
                                <p>{{ item.name_en }}</p>
                              </td>
                              <td>
                                <p style="white-space: break-spaces;">{{ item.address_ar }}</p>
                                <p style="white-space: break-spaces;">{{ item.address_en }}</p>
                              </td>
                              <td>
                                  {{ item.nationality_code }}
                              </td>
                              <td>
                                {{ item.residence_country_code }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-show="name_addr.ind_change_inventor == 'Y'">
                    <h2 class="m_title back__type mt-35">{{ $t('component.amended_biblio_details.inventor2') }}</h2>
                    <v-row class="mt-25">
                      <v-col cols="12" class="pb-0">
                        <div class="floating__title__self">{{ $t('common.button.before') }}</div>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-data-table
                          :headers="$getHeaderType1(inventorHeaderTxt, inventorHeaders)"
                          :items="beforeInventorList"
                          hide-default-footer
                          disable-pagination
                          class="elevation-0 myapp_table_type2 type4 overflow-x-auto"
                        >
                          <template v-slot:item="{ item, index }">
                            <tr>
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td>
                                <p>{{ item.name_ar }}</p>
                                <p>{{ item.name_en }}</p>
                              </td>
                              <td>
                                <p style="white-space: break-spaces;">{{ item.address_ar }}</p>
                                <p style="white-space: break-spaces;">{{ item.address_en }}</p>
                              </td>
                              <td>
                                {{ item.residence_country_code }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <v-row class="mt-25">
                      <v-col cols="12" class="pb-0">
                        <div class="floating__title__self ty2">{{ $t('common.button.after') }}</div>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-data-table
                          :headers="$getHeaderType1(inventorHeaderTxt, inventorHeaders)"
                          :items="afterInventorList"
                          hide-default-footer
                          disable-pagination
                          class="elevation-0 myapp_table_type2 type4 overflow-x-auto disabled"
                        >
                          <template v-slot:item="{ item, index }">
                            <tr>
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td>
                                <p>{{ item.name_ar }}</p>
                                <p>{{ item.name_en }}</p>
                              </td>
                              <td>
                                <p style="white-space: break-spaces;">{{ item.address_ar }}</p>
                                <p style="white-space: break-spaces;">{{ item.address_en }}</p>
                              </td>
                              <td>
                                {{ item.residence_country_code }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>


                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!contentConfirm"
                          @click.stop="fnConfirmContent()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="contentConfirm"
                          @click.stop="fnCancelContent()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        ><v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>

                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item :value="`tab-2`">
                  <DocumentViewer :items="documentFileList"/>
                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>


                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!docConfirm"
                          @click.stop="fnConfirmDoc()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="docConfirm"
                          @click.stop="fnCancelDoc()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        ><v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>

                    </div>
                  </div>

                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation from '@/components/layout/ApplicationInformation'

export default {
  name: 'ChangeNameAddressStep3',
  components :{
    DocumentViewer,
    ApplicationInformation
  },
  data () {
    return {
      activeTab : 'tab-1',
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],
      name_addr : {
        ind_change_applicant : 'N',
        ind_change_inventor : 'N'
      },

      applicantHeaderTxt : {
        prefix : 'modification.changenameaddress.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },
      applicantHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('modification.changenameaddress.fields.name'), align: 'center', width: '350', sortable: false, value: '' },
        { text: this.$t('modification.changenameaddress.fields.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.changenameaddress.fields.nationality_country_code'), align: 'center', width: '100', sortable: false, value: '' },
        { text: this.$t('modification.changenameaddress.fields.residence_country_code'),  align: 'center', width: '100', sortable: false, value: '' }
      ],
      beforeApplicantList : [],
      afterApplicantList : [],

      inventorHeaderTxt : {
        prefix : 'modification.changenameaddress.fields.',
        txt : [ '#', 'name','address','residence' ]
      },
      inventorHeaders: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('modification.changenameaddress.fields.name'), align: 'center', width: '350', sortable: false, value: '' },
        { text: this.$t('modification.changenameaddress.fields.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.changenameaddress.fields.residence'),  align: 'center', width: '100', sortable: false, value: '' }
      ],
      beforeInventorList : [],
      afterInventorList : [],

      docConfirm : false,
      contentConfirm : false,
    }
  },
  computed : {
    confirmYn (){
      return this.docConfirm && this.contentConfirm
    }
  },
  mounted(){
    window.scrollTo(0, 0)

    this.fnGetReceipt()
    this.fnGetNameAddress()
    this.fnGetDocumentFileList()
    this.fnGetApplicantList()
    this.fnGetInventorList()
    this.fnGetApplicantOrgList()
    this.fnGetInventorOrgList()
  },
  methods: {
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.receipt_status_type_code !== '4301' || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetNameAddress(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.name_addr.seq                       = res.data.seq
            this.name_addr.ind_change_applicant      = res.data.ind_change_applicant
            this.name_addr.ind_change_inventor       = res.data.ind_change_inventor

          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetNameAddress()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetApplicantList(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no + '/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.afterApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicantList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetApplicantOrgList(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no + '/applicants/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.beforeApplicantList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicantOrgList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetInventorList(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no + '/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.afterInventorList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventorList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetInventorOrgList(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no + '/inventors/org',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.beforeInventorList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventorOrgList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmDoc(){
      let params = {
        ind_attached_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = true

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnCancelDoc(){
      let params = {
        ind_attached_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = false

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmContent(){
      let params = {
        request_content_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = true
            this.activeTab = 'tab-2'

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnCancelContent(){
      let params = {
        request_content_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = false

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGoBefore(){
      this.$router.push({path:'/modification/changenameaddress/step2/' + this.receipt_no})
    },
    fnSubmit(){
      requestApi({
        url: '/receivings/change/name/address/' + this.receipt_no + '/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.$router.push({path : '/myrequest/list'})
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
  }
}
</script>